define((require) => {
    "use strict";

    const ImprovedModel              = require("shared/zbone/ImprovedModel");

    /**
     * View model for Experience Export
     *
     * @class ExportModel
     * @constructor
     */
    return ImprovedModel.extend("Export", {

        selection: null,
        defaults: {
            experienceExportApiKey: null,
            triggerOrigin: null
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/export/ExportModel.js